import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import i18next from 'i18next';

import { PageTitle } from '../PageTitle';
import { ThresholdsService } from '../../services';
import { FormatHelper } from '../../helpers';

import config from "config";

const ThresholdView = ({match, location}) => {
  const [threshold, setThreshold] = useState(null);
  const [alerts, setAlerts] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const thresholdId = match.params.thresholdId;

  useEffect(() => {
    ThresholdsService.get(thresholdId).then((response) => {
      setThreshold(response.threshold);
    }).catch((error) => {
      setErrorMessage(i18next.t('messages.could-not-load-threshold-view'));
      console.error(error);
    });
    ThresholdsService.getAssociatedAlerts(thresholdId).then((response) => {
      setAlerts(response.alerts);
    }).catch((error) => {
      setErrorMessage(i18next.t('messages.could-not-load-associated-alerts'));
      console.error(error);
    });
  }, [thresholdId]);

  if (errorMessage) {
    return (<Redirect to={{ pathname: '/config/thresholds', state: { errorMessage: errorMessage } }} />);
  } else {
    if (threshold && alerts) {
        return <ThresholdDetail threshold={threshold} alerts={alerts} backLinkSearch={location.state?.backLinkSearch ?? null} />;
    } else {
        return <div className="loader">{i18next.t("loading")}</div>;
    }
  }
}

const ThresholdDetail = ({threshold, alerts, backLinkSearch}) => {
  const measurementValue = FormatHelper.formatMeasurement(threshold);
  const sensorToken = threshold.deviceDataType?.token || threshold.deviceDataClassification?.token;

  return (
      <div>
        <div className="row">
          <PageTitle title={threshold.name}
                      editLinkWithParams={{ link: { pathname: `/config/thresholds/edit/${threshold.id}`, uiroute: '/config/thresholds/edit/:thresholdId', state: { backLinkSearch: backLinkSearch } } }}
                      backLinkWithParams={{ link: { pathname: "/config/thresholds", search: backLinkSearch } }} 
          />
        </div>

        <div className="op-content-box">
          <div className="row">
            <div className="col-sm-12 col-md-5">
              <div className="row">
                <div className="col-sm-12 form-group">
                  <div className="card-data-cell remove-border-left card-data-cell-icon card-icon-business-structure">
                    <label>{i18next.t('form-labels.tags')}</label><p>{threshold.tags.map(tag => tag.name).join(', ')}</p>
                  </div>
                </div>
                <div className="col-sm-12 form-group">
                  <div className="card-data-cell remove-border-left card-data-cell-icon card-icon-description">
                    <label>{i18next.t('form-labels.description')}</label> <p>{threshold.description}</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-12 col-md-7">
              <div className="card-data-side-info">
                <div className="row">
                  <div className="col-sm-12 col-md-6 form-group">
                    <div className="card-data-cell remove-border-left">
                      <label>{i18next.t('form-labels.measurement')}</label>
                      <p>
                        <img src={`${config.WEB_BASE_URL}/images/icon/sensor_${sensorToken}.svg`} height="16" /> {i18next.t(`device-data-types.${sensorToken}`)} <span className="threshold-evaluation">{threshold.thresholdEvaluationType.shortForm}</span> {measurementValue}
                      </p>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 form-group">
                      <div className="card-data-cell remove-border-left">
                        <label>{i18next.t('form-labels.value')}</label> <p>{measurementValue}</p>
                      </div>
                  </div>
                  <div className="col-sm-12 col-md-6 form-group">
                    <div className="card-data-cell remove-border-left">
                      <label>{i18next.t('form-labels.classification')}</label>
                      <p>
                        <img height="16" src={`${config.WEB_BASE_URL}/images/icon/sensor_${threshold.thresholdClassification.token}.svg`} /> {i18next.t(`threshold-classifications.${threshold.thresholdClassification.token}`)}
                      </p>
                    </div>
                  </div>
                  {
                    alerts.length > 0 &&
                    <div className="col-sm-12 form-group">
                      <div className="card-data-cell remove-border-left">
                        <label>{i18next.t('form-labels.associated-alert-configurations')} ({alerts.length})</label>
                        { alerts.map((alert, index) => <p key={index}>{alert.name}</p>) }
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
  );
}

export default ThresholdView;
